import { styled } from 'styled-components'

import { Button } from '@b-stock/fe-core/bstock-react'
import { Breakpoints } from '@b-stock/fe-core/design-system'
import { designColors } from '@b-stock/fe-core/theme'

// LINK TO FIGMA
// https://www.figma.com/file/Y6PCaMlqSUA6lFwUDSAJtr/MVP---SP%2FBP%2FCSP---Listings%2C-Bidding-Experience?type=design&node-id=90-202429&mode=design&t=4uB7vZJyZmFyWML1-0

export const ActionButton = styled(Button)`
  width: 100%;
  word-wrap: nowrap;

  @media ${Breakpoints.min.large} {
    height: 3.5rem;
  }
`

export const OrangeActionButton = styled(ActionButton)<{ appearance?: string }>`
  ${({ appearance }) =>
    (!appearance || appearance === 'primary') &&
    `
    background-color: #b45309;
    border-color: transparent;
    font-size: 1.125rem;

    &:hover {
      background-color: #c75b0a;
    }

    &:active {
      background-color: #92400e;
    }

    &:disabled {
      background-color: ${designColors.neutral.mediumGray};
      cursor: default;
    }
  `}
`

export const RedActionButton = styled(ActionButton)<{ appearance?: string }>`
  ${({ appearance }) =>
    (!appearance || appearance === 'primary') &&
    `
    background-color: #b91c1c;
    border-color: transparent;
    font-size: 1.125rem;

    &:hover {
      background-color: #c81e1e;
    }

    &:active {
      background-color: #991b1b;
    }

    &:disabled {
      background-color: ${designColors.neutral.mediumGray};
      cursor: default;
    }
  `}
`
